<!-- Cell templates for the data table -->
<ng-template #categoriesTpl let-inc>
  <div class="flex flex-wrap gap-1">
    @for (cat of inc.categories; track cat) {
      <span
        class="px-2 py-0.5 rounded-full text-xs bg-surface-200 text-slate-600 font-medium whitespace-nowrap"
      >
        {{ cat }}
      </span>
    }
  </div>
</ng-template>

<ng-template #personsTpl let-inc>
  <div class="flex items-center gap-2">
    <img src="/icons/persons-icon.svg" class="w-4 h-4 shrink-0" alt="" />
    <span class="text-slate-600 text-xs">{{ inc.personsInvolved.join(', ') }}</span>
  </div>
</ng-template>

<ng-template #stageTpl let-inc>
  <span
    class="px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap"
    [style.background]="stageStyle(inc.currentStage).background"
    [style.color]="stageStyle(inc.currentStage).color"
  >
    {{ inc.currentStage.toLowerCase() !== 'completed' ? 'Stage ' : '' }} {{ inc.currentStage }}
  </span>
</ng-template>

<!-- Mobile FAB -->
<button
  class="fixed bottom-6 right-6 z-30 md:hidden flex items-center gap-2 pl-4 pr-5 py-3 text-sm font-semibold text-white bg-accent-500 hover:bg-accent-600 rounded-full shadow-lg transition-colors cursor-pointer"
  (click)="router.navigate(['/incidents', 'new'])"
>
  <img src="/icons/plus-icon.svg" class="w-4 h-4 brightness-0 invert" alt="" />
  New Incident
</button>

<!-- Page layout -->
<div class="flex flex-col h-full bg-surface-100 px-4 sm:px-10 py-6 gap-4">
  <app-filter-bar
    [programs]="programOptions()"
    [categories]="categoryOptions()"
    [stages]="stageOptions"
    searchPlaceholder="Filter by person name or location ..."
    (filtersChange)="onFiltersChange($event)"
  />

  <div
    class="flex-1 min-h-0 bg-white rounded-xl border border-slate-100 overflow-hidden flex flex-col"
  >
    <app-data-table
      [columns]="columns()"
      [rows]="incidents()"
      [pageSize]="10"
      [total]="total()"
      [page]="currentPage()"
      [clickableRows]="true"
      [loading]="loading()"
      [sortBy]="sortBy()"
      [sortDirection]="sortDirection()"
      (rowAction)="onRowAction($event)"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
    />
  </div>
</div>
